export const fees = {
  individual: '10,000 Rwf',
  company: '30,000 Rwf',
};
